module.exports = __webpack_public_path__ + "static/media/drlicita.4a717d80.svg";